export function convertTextToLinks(text) {
    //... Regular expression to match URLs
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    //... Replace plain text URLs with anchor tags
    return text.replace(urlRegex, function (url) {
        console.log("url", url)
        return '<a target="_blank" href="' + url + '">' + "link" + '</a>';
    });
}